import { Component, OnInit, Input, Output, EventEmitter, Inject } from '@angular/core';
import { SolutionParticipationService } from '../../service/solution-participation.service';
import { FEATURE_FLAGS, FeatureFlags } from 'src/app/config/AppInitializer.factory';

@Component({
    selector: 'app-solution-participation-summary',
    templateUrl: './solution-participation-summary.component.html',
    styleUrls: ['./solution-participation-summary.component.scss'],
    standalone: false
})
export class SolutionParticipationSummaryComponent implements OnInit {

  @Input() numSolutions: number = 0;
  @Output() locationsEvent = new EventEmitter<number>();
  @Input() currencySymbol: string = '';
  @Input() isLoading: boolean = false;

  constructor(
    private _solutionParticipationService: SolutionParticipationService,
    @Inject(FEATURE_FLAGS) private _featureFlags: FeatureFlags
  ) {
   }

  get isRefreshedUIEnabled() {
    return this._featureFlags.enableRefreshedSolutionParticipationUI;
  }

  ngOnInit(): void {
  }

  get solutionsPerLocation(): number {
    return this._solutionParticipationService.solutionsPerLocation;
  }

  get sumProducts(): number {
    return this._solutionParticipationService.sumProducts;
  }

  get sumSolutionGroups(): number {
    return this.numSolutions;
  }

  get sumLocations(): number {
    return this._solutionParticipationService.sumLocations;
  }

  get sumSales(): number {
    return this._solutionParticipationService.sumSales;
  }

  get sumCases(): number {
    return this._solutionParticipationService.sumCases;
  }
}
